import type { GetterTree } from 'vuex';
import type { RootState } from '../../store/root.types';
import { TrackingGetter } from './tracking.constants';
import type { TrackingState } from './tracking.types';

export const getters: GetterTree<TrackingState, RootState> = {
  [TrackingGetter.PageViewStopWatchPaused](state: TrackingState): boolean {
    return state.pageViewStopWatchPaused;
  },
};
